// @packages
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';

// @scripts
import CtrlCommonControls from './common-controls';
import CtrlRestrictedControls from './restricted-controls';
import CtrlRoutes from './routes';
import CtrlHeader from './header';
import { theme } from '../../styles/material-ui';


// @styles
import styles from './styles';

const MasterPage = ({
    appName,
    classes,
    currentUrl,
    loadingPageProps,
    mainMenuProps,
    modalDialogProps,
    toastNotificationProps
}) => (
    <MuiThemeProvider theme={theme}>
        <CtrlHeader/>
        <div
            id="master-page"
            className={classes.masterPage}
            style={{ background: theme.palette.background.default, position: 'relative' }}
        >
            <Helmet>
                <title>{appName}</title>
            </Helmet>
            <CtrlRoutes
                currentUrl={currentUrl}
                mainMenuIsExpanded={mainMenuProps.isExpanded}
            />
            <CtrlCommonControls
                currentUrl={currentUrl}
                modalDialogProps={modalDialogProps}
                loadingPageProps={loadingPageProps}
                toastNotificationProps={toastNotificationProps}
            />
            <CtrlRestrictedControls
                appName={appName}
                currentUrl={currentUrl}
                mainMenuProps={mainMenuProps}
                pageTitle="Mi Página"
            />
        </div>
    </MuiThemeProvider>
);

MasterPage.propTypes = {
    appName: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    mainMenuProps: PropTypes.shape({
        isExpanded: PropTypes.bool.isRequired,
        onCollapse: PropTypes.func.isRequired,
        onExpand: PropTypes.func.isRequired
    }).isRequired,
    modalDialogProps: PropTypes.shape({
        cancelLabel: PropTypes.string,
        isVisible: PropTypes.bool.isRequired,
        msg: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        okLabel: PropTypes.string,
        onConfirm: PropTypes.func,
        onHide: PropTypes.func.isRequired,
        title: PropTypes.string
    }).isRequired,
    currentUrl: PropTypes.string.isRequired,
    loadingPageProps: PropTypes.shape({
        isVisible: PropTypes.bool.isRequired,
        msg: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    }).isRequired,
    toastNotificationProps: PropTypes.shape({
        isVisible: PropTypes.bool.isRequired,
        msg: PropTypes.string,
        onHide: PropTypes.func.isRequired,
        type: PropTypes.string
    }).isRequired
};

export default withStyles(styles)(MasterPage);
